import * as React from "react";
import {Fragment} from "react";
import Spinner from "./Spinner";

class Process extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		const {title, children} = this.props;

		return (
			<Fragment>
				<div className="process">
					<div className="row align-items-center h-100">
						<div className="col text-center">
							<Spinner />
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}

export default Process;
